import axios from "axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";
import { categoriaGastoApi } from "./axios";

export interface CategoriaGastoI {
  id: number;
  codigo: string;
  nombre: string;
  icono: string | null;
  color: string | null;
  orden: number;
}

export interface CategoriaAsignadaI {
  categoriaGastoId: number;
  nombre: string;
  codigo: string;
  esDefault: boolean;
}

/** Catálogo fijo de categorías de gasto (Vivienda, Educación, etc.) */
export const listCategoriasGasto = async (): Promise<CategoriaGastoI[]> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await categoriaGastoApi.get("/categoria-gasto", {
      headers: { Authorization: token },
    });
    return data?.data ?? [];
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error(
      (obj?.data as Error)?.message ?? "Error al cargar categorías",
    );
  }
};

/** Categorías asignadas a un proveedor puntual (id encriptado, igual que el resto de rutas de supplier) */
export const getCategoriasSupplier = async (
  supplierId: string,
): Promise<CategoriaAsignadaI[]> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await categoriaGastoApi.get(
      `/supplier-stk/${supplierId}/categorias`,
      { headers: { Authorization: token } },
    );
    return data?.data ?? [];
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error(
      (obj?.data as Error)?.message ??
        "Error al cargar categorías del proveedor",
    );
  }
};

export const setCategoriasSupplier = async (
  supplierId: string,
  payload: {
    categoriaDefaultId: number;
    categoriaIds: number[];
    reclasificarExistentes?: boolean;
  },
): Promise<string> => {
  try {
    const token = ValidateCurrentToken();
    if (!token) throw new Error("TOKEN INVALIDO");
    const { data } = await categoriaGastoApi.put(
      `/supplier-stk/${supplierId}/categorias`,
      payload,
      { headers: { Authorization: token } },
    );
    return data?.data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error(
      (obj?.data as Error)?.message ?? "Error al guardar categorías",
    );
  }
};
